import { render, staticRenderFns } from "./HandicapComparison.vue?vue&type=template&id=2c6b5860&scoped=true"
import script from "./HandicapComparison.vue?vue&type=script&lang=js"
export * from "./HandicapComparison.vue?vue&type=script&lang=js"
import style0 from "./HandicapComparison.vue?vue&type=style&index=0&id=2c6b5860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b5860",
  null
  
)

export default component.exports